<template>
  <div id="approval-buttons" class="d-flex flex-row i-gap-2">
    <status-button
      label="Reject"
      v-read-only-check
      data-testid="reject-button"
      :btn-status="statusButtonOptions.REJECT"
      :on-btn-click="rejectCustomer"
      icon="small-user-reject"
      :active="isCustomerRejected"
      active-class="i-text-error-90"
    ></status-button>

    <status-button
      label="Approve"
      v-read-only-check
      data-testid="accept-button"
      :btn-status="statusButtonOptions.APPROVE"
      :on-btn-click="approveCustomer"
      icon="small-user-approve"
      :active="isCustomerApproved"
      active-class="i-text-success-90"
    ></status-button>
  </div>
</template>

<script>
import * as documentStatusOptions from '@/constants/documentStatus';
import { mapActions, mapMutations } from 'vuex';
import StatusButton from '@/V2/components/StatusButton';
import { StatusButtonOptions } from '@/constants/statusButtonOptions';
import palette from '@inscribe/signal/dist/palette';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    StatusButton,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    groupedParsedDetails: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    options: documentStatusOptions,
    statusButtonOptions: StatusButtonOptions,
    palette,
    loading: false,
  }),

  computed: {
    isCustomerApproved() {
      return this.customer && this.customer.approved === true;
    },
    isCustomerRejected() {
      return this.customer && this.customer.approved === false;
    },
    customerApprovalNull() {
      return this.customer && this.customer.approved === null;
    },
  },
  mounted() {
    this.setShowBlocklistSuggestions(false);
  },
  methods: {
    ...mapActions(['updateCustomer', 'fetchAndCacheCustomer']),
    ...mapMutations(['setShowBlocklistSuggestions', 'setSelectedCustomer']),
    rejectCustomer() {
      this.setCustomerApproved(false);
      if (this.groupedParsedDetails && this.groupedParsedDetails.length > 0) {
        setTimeout(() => {
          this.setShowBlocklistSuggestions(true);
        }, 600);
      }
      // This component still uses the deprecated selectedCustomer state.
      // But to "future proof" this component, refetch and cache the customer
      // in CustomersStore which is the preferred data flow.
      this.fetchAndCacheCustomer(this.customer.id);
    },
    approveCustomer() {
      this.setCustomerApproved(true);
      // Refetch and cache the customer in CustomersStore
      this.fetchAndCacheCustomer(this.customer.id);
    },
    setCustomerApproved(isApproved) {
      let newValue = isApproved;
      if (
        (isApproved === true && this.customer.approved === true) ||
        (isApproved === false && this.customer.approved === false)
      ) {
        newValue = null;
      }

      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMER_CTA_CLICKED, {
        itemName: isApproved ? 'approve-button' : 'reject-button',
        value: newValue,
      });

      this.loading = true;
      const updatedCustomer = {
        ...this.customer,
        approved: newValue,
      };
      this.updateCustomer({
        ...updatedCustomer,
        addresses: undefined,
        phone_numbers: undefined,
        tins: undefined,
        emails: undefined,
      });
      this.setSelectedCustomer(updatedCustomer);
      this.loading = false;
    },
  },
};
</script>
